'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (_ref) {
  var _ref$apiKey = _ref.apiKey,
      apiKey = _ref$apiKey === undefined ? '' : _ref$apiKey,
      _ref$bucket = _ref.bucket,
      bucket = _ref$bucket === undefined ? 'component-cache' : _ref$bucket,
      _ref$draft = _ref.draft,
      draft = _ref$draft === undefined ? false : _ref$draft,
      _ref$host = _ref.host,
      host = _ref$host === undefined ? 'https://api.trymason.com' : _ref$host,
      versionNumber = _ref.versionNumber;

  var serveEndpoint = function serveEndpoint(_ref2) {
    var cIds = _ref2.cIds,
        format = _ref2.format,
        pIds = _ref2.pIds;
    var query = 'apiKey=' + encodeURIComponent(apiKey);

    if (_lodash2.default.isArray(cIds) && cIds.length) {
      query += '&' + _lodash2.default.map(cIds, function (cId) {
        return 'cIds=' + cId;
      }).join('&');
    }

    if (_lodash2.default.isArray(pIds) && pIds.length) {
      query += '&' + _lodash2.default.map(pIds, function (pId) {
        return 'pIds=' + pId;
      }).join('&');
    }

    if (format === 'css') {
      query += '&format=css';
    }

    if (draft) {
      query += '&draft=true';
    }

    if (versionNumber) {
      query += '&libraryVersion=' + versionNumber;
    }

    return host + '/serve?' + query;
  };

  return {
    urls: {
      stylesheet: function stylesheet(_ref3) {
        var pId = _ref3.pId;

        if (draft) {
          return serveEndpoint({
            format: 'css',
            pIds: [pId]
          });
        }

        return 'https://' + bucket + '.s3.amazonaws.com/css/' + pId + '.css.gz?mode=cors';
      },
      components: serveEndpoint,
      error: function error() {
        var query = 'apiKey=' + encodeURIComponent(apiKey);
        return host + '/errors?' + query;
      }
    }
  };
};